import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conditional-field"
// Shows/hides target elements based on a trigger element's value
//
// Usage:
//   <div data-controller="conditional-field">
//     <input type="checkbox" data-conditional-field-target="trigger" data-action="change->conditional-field#toggle">
//     <div data-conditional-field-target="dependent">Only shown when checked</div>
//   </div>
//
// For select fields with specific values:
//   <select data-conditional-field-target="trigger" data-action="change->conditional-field#toggle" data-conditional-field-show-value="specific_value">
//   <div data-conditional-field-target="dependent">Only shown when value matches</div>
//
export default class extends Controller {
  static targets = ["trigger", "dependent"]

  connect() {
    this.toggle()
  }

  toggle() {
    const trigger = this.triggerTarget
    let shouldShow = false

    if (trigger.type === "checkbox") {
      shouldShow = trigger.checked
    } else if (trigger.tagName === "SELECT") {
      const showValue = trigger.dataset.conditionalFieldShowValue
      if (showValue) {
        shouldShow = trigger.value === showValue
      } else {
        shouldShow = trigger.value !== ""
      }
    }

    this.dependentTargets.forEach((el) => {
      el.style.display = shouldShow ? "" : "none"
    })
  }
}
